/* eslint-disable @typescript-eslint/no-unsafe-call */
/**
 * ResponseWithForm Component
 * Combines Response-style header with form content below
 */

import React from 'react';
import { Icon, Typography } from '@saviynt/design-system';

import { useLocalization } from '../../../../hooks';
import { useApplicationName } from '../../hooks';

import './ResponseWithForm.css';

interface ResponseWithFormProps {
  responseText: string;
  children: React.ReactNode;
}

/**
 * ResponseWithForm - Response header + form content
 */
function ResponseWithForm({ responseText, children }: ResponseWithFormProps) {
  const formatMessage = useLocalization();
  const applicationName: string = useApplicationName();

  const translatedText = formatMessage(responseText, responseText, {
    applicationName,
  });

  // Check if translatedText is one line (no line breaks)
  const isOneLine = !translatedText.includes('\n');
  const containerClass = `Copilot-ResponseWithForm${
    isOneLine ? ' Copilot-ResponseWithForm--one-line' : ''
  }`;

  return (
    <div className={containerClass}>
      {/* Response Header (reusing existing Response component styles) */}
      <div className='Integrations'>
        <div className='Integrations-Responses'>
          <span>
            <Icon
              className='Integrations-Responses-Icon'
              kind='SaviCompanion'
              color='--color-foreground-savi-medium'
            />
          </span>
          <Typography
            className='Integrations-Responses-Text'
            kind='body2'
            desktop='body2-d'
            mobile='body2-d'>
            {translatedText}
          </Typography>
        </div>
      </div>

      {/* Form Content */}
      {children}
    </div>
  );
}

export default ResponseWithForm;
